export enum GricsSectionType {
  Building = 'B',
  Contribution = 'C',
  Employment = 'E',
  Member = 'M',
  School = 'A',
}
